<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            Distributors
        </li>
    </ol>
</nav>
<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-9 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">All Distributors List</h5>
                </div>

            </div>
            <hr class="p-0 m-0">
            <hr class="p-0 m-0">

            <div class="row">
                <div class="col-lg-4">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search by Name, Email, GST No, or Phone</mat-label>
                        <input matInput [(ngModel)]="filter.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>

                <div class="col-lg-4">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By City/State</mat-label>
                        <input matInput [(ngModel)]="filter.cityState" name="cityState"
                            (input)="onCityStateChange($event)">
                    </mat-form-field>
                </div>
                @if(!isCompanyLoggedIn){
                <div class="col-lg-4 ">
                    <ng-select [items]="allCompanies" bindLabel="name" bindValue="_id" placeholder="Select Company"
                        [(ngModel)]="filter.companyId" name="companyId" (change)="companyFilter($event)">
                    </ng-select>
                </div>
                }
            </div>

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="compact-table table-bordered">
                        <!-- Position Column -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <!-- <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef> Company </th>
                            <td mat-cell *matCellDef="let element"> {{element?.company?.name}} </td>
                        </ng-container> -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>WHL Name </th>
                            <td mat-cell *matCellDef="let element"> {{element?.distributor?.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="contact">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Contact </th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div class="d-flex flex-column gap-1">

                                    <div>
                                        <i class="bi bi-envelope-fill me-1 text-secondary"></i> {{
                                        element?.distributor.email }}
                                    </div>
                                    <div><i class="bi bi-telephone-fill me-1 text-secondary"></i> {{
                                        element?.distributor.phone }}</div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="gst">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> GST NO. </th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div class="d-flex flex-column gap-1">

                                    <div>

                                        {{element?.distributor?.gstNo || "-" }}
                                    </div>

                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cordinates">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Coordinates (Lng, Lat)
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.distributor?.location?.coordinates[0] }}<br>
                                {{ element.distributor?.location?.coordinates[1] }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 200px;">Address</th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div style="width: 200px; white-space: normal; word-wrap: break-word;">
                                    {{ element?.distributor?.address }},
                                    <br>
                                    {{ element?.distributor?.city }},
                                    {{ element?.distributor?.state }}
                                </div>
                            </td>
                        </ng-container>
                        <!-- Symbol Column -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Created At </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.distributor.createdAt | date:'dd/MM/yyyy' }}<br>
                                <small>{{ element.distributor.createdAt | date:'hh:mm a' }}</small>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="preview">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center"> Preview </th>
                            <td mat-cell *matCellDef="let element">

                                <button mat-icon-button class="btn btn-sm ">
                                    <mat-icon class="c_btn" (click)="openModel(element._id)">visibility</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="samples">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center"> Samples </th>
                            <td mat-cell *matCellDef="let element">

                                <button mat-icon-button class="btn btn-sm ">
                                    <mat-icon class="c_btn"
                                        [routerLink]="['/sample/issuedToDistributors',element._id,1]">visibility</mat-icon>
                                </button>
                            </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

            <mat-paginator #paginator [length]="total" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllDistributors($event)">
            </mat-paginator>


        </app-card>
    </div>
</div>



<!-- Button trigger modal -->


<!-- Modal -->

<div class="modal fade" id="registerModal" tabindex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" [ngClass]="{
       'modal-sm': distributorPreview?.length <= 2,
       'modal-md': distributorPreview?.length > 2 && distributorPreview?.length <= 6,
       'modal-lg': distributorPreview?.length > 6
     }">

        <div class="modal-content">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-6 fw-semibold d-flex flex-column" id="registerModalLabel">
                    <span>{{ dData?.name }}</span>
                    <small class="fw-normal text-muted" style="font-size: 0.8rem;">
                        {{ dData?.email || 'No Email' }} &nbsp;|&nbsp; {{ dData?.address }}
                    </small>
                </h5>

                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>
            <div class="modal-body pt-2">
                <div class="d-flex justify-content-start gap-2 mb-3">
                    <button type="button" class="btn btn-sm rounded-2"
                        [ngClass]="{ 'btn-primary': selectedType === 0, 'btn-outline-primary': selectedType !== 0 }"
                        (click)="changeType(null)">
                        All
                    </button>
                    <button type="button" class="btn btn-sm rounded-2"
                        [ngClass]="{ 'btn-primary': selectedType === 1, 'btn-outline-primary': selectedType !== 1 }"
                        (click)="changeType(1)">
                        Wholesalers
                    </button>
                    <button type="button" class="btn btn-sm rounded-2"
                        [ngClass]="{ 'btn-primary': selectedType === 2, 'btn-outline-primary': selectedType !== 2 }"
                        (click)="changeType(2)">
                        Retailers
                    </button>
                </div>

                @if (distributorPreview?.length > 0) {
                <div class="row g-2">
                    @for (d of distributorPreview; track d._id) {
                    <div class="col-lg-3 col-md-4 col-sm-4 text-center">
                        <div style="padding: 4px;">
                            <img [src]="getImg(d.companyId.trimImage)" alt="Logo" [title]="d.companyId.name"
                                style="border: #B0B0B0 solid 2px;width: 66px;height: 66px;" class="rounded-circle" />
                            <div class="mt-1">
                                <span class="badge rounded-pill px-2 py-1" [ngStyle]="{
                                    backgroundColor: d.distributorType === 1 ? '#006B88' : '#003E53',
                                    color: 'white'
                                }">
                                    {{ d.distributorType === 1 ? 'WHL' : 'RTL' }}
                                </span>
                            </div>
                        </div>
                    </div>
                    }
                </div>


                } @else {
                <div class="text-center text-muted">No distributor data available.</div>
                }
            </div>


        </div>

    </div>
</div>